import { AclOwnership } from './AclOwnership';

export const roleAccessTypes = {
  create: 'C',
  read: 'R',
  update: 'U',
  list: 'L',
  delete: 'D',

  anyRead: `${AclOwnership.Any}:R`,
  anyList: `${AclOwnership.Any}:L`,
  ownRead: `${AclOwnership.Own}:R`,

  hasAccess: 'R',
};
